import React from 'react';

import { IconPaymentTypeApplePay, IconPaymentTypeCard, IconPaymentTypeGooglePay } from '@fhs/ui';
import { Box, Icon } from '@fhs-legacy/universal-components';
import { CardTypes } from 'state/payment/types';
import { mapPaymentMethodCardTypes } from 'utils/payment/map-payment-method-card-type';

const BlankCard = Box.withConfig({
  backgroundColor: Styles.color.grey.four,
  height: '$5',
  width: '$6',
});

const cardTypeToIcon = {
  [CardTypes.VISA]: <IconPaymentTypeCard size={24} />,
  [CardTypes.MASTERCARD]: <IconPaymentTypeCard size={24} />,
  [CardTypes.AMEX]: <IconPaymentTypeCard size={24} />,
  [CardTypes.DISCOVER]: <IconPaymentTypeCard size={24} />,
  [CardTypes.APPLE_PAY]: <IconPaymentTypeApplePay size={24} />,
  [CardTypes.GOOGLE_PAY]: <IconPaymentTypeGooglePay size={40} />,
  [CardTypes.PAYPAL]: <Icon title="PayPal" variant="paypal" />, // TODO: confirm if we still support PayPal
  [CardTypes.JCB]: <IconPaymentTypeCard size={24} />,
  [CardTypes.DINERSCLUB]: <IconPaymentTypeCard size={24} />,
} as const;

export const cardIconRenderer = (methodType: string): JSX.Element => {
  const cardType = mapPaymentMethodCardTypes(methodType);
  if (!cardType || !cardTypeToIcon[methodType]) {
    return <BlankCard />;
  }

  return cardTypeToIcon[methodType];
};
